import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { isMobile } from "react-device-detect";

const FloatingAgendarButton = ({ targetRef, isLoading, serviceCardsRef, profesionalInfo }) => { // NUEVO: Recibir profesionalInfo
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // NUEVO: Verificar si hay servicios disponibles
    const tieneServicios = profesionalInfo?.servicio_consulta || 
                          profesionalInfo?.servicio_domicilio || 
                          profesionalInfo?.servicio_remoto;

    // No mostrar el botón mientras los datos están cargando, si no es móvil, o si no hay servicios
    if (isLoading || !isMobile || !tieneServicios) { // MODIFICADO: Agregar validación de servicios
      setShowButton(false);
      return;
    }

    const handleScroll = () => {
      // Si la referencia a la sección "Agendar" no existe, no hacemos nada
      if (!targetRef.current) {
        return;
      }

      // Obtenemos la posición de la sección "Agendar" en la pantalla
      const targetRect = targetRef.current.getBoundingClientRect();

      // La lógica es: MUESTRA el botón si la parte de arriba de la sección "Agendar"
      // está todavía por debajo de la vista del usuario.
      // Cuando la sección sube y entra en la pantalla, la condición se vuelve falsa y el botón se OCULTA.
      const shouldShow = targetRect.top > window.innerHeight - 200;
      
      setShowButton(shouldShow);
    };

    // Agregamos el listener para detectar el scroll
    window.addEventListener("scroll", handleScroll);

    // Hacemos una comprobación inicial por si la página carga ya scrolleada
    setTimeout(handleScroll, 300);

    // Limpiamos el listener cuando el componente se desmonta para evitar errores
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
    // El efecto ahora solo depende de estas variables para ejecutarse de nuevo
  }, [targetRef, isLoading, isMobile, profesionalInfo]); // MODIFICADO: Agregar profesionalInfo a dependencias

  const scrollToTarget = () => {
    if (targetRef.current) {
      const yOffset = -20; // Un pequeño margen superior
      const y =
        targetRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  // El componente no renderiza nada (null) si no es móvil o si el estado es de no mostrarse
  if (!isMobile || !showButton) {
    return null;
  }

  // Si debe mostrarse, renderiza el botón
  return (
    <Button
      variant="contained"
      onClick={scrollToTarget}
      sx={{
        fontFamily: "Quicksand-Bold",
        backgroundColor: "#3B82F6",
        "&:hover": { backgroundColor: "#2563EB" },
        borderRadius: 3,
        position: "fixed",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        width: "90%",
        zIndex: 1000,
        py: 1.5,
        boxShadow: 3,
      }}
    >
      Agendar
    </Button>
  );
};

export default FloatingAgendarButton;
